import {ApiRes} from '../../types/api'
import {apiGet} from '../api'

export const getGecko = async (days: number, interval: string = 'daily'): Promise<ApiRes<number[]>> => {
    return await apiGet(
        'https://api.coingecko.com/api/v3/coins/',
        `bitcoin/market_chart?days=${days}&interval=${interval}&vs_currency=usd`,
    )
}
